module.exports = __webpack_public_path__ + "static/media/emoji-neutral.6dbb0efb.svg";